import { Integration_Names_Enum } from '@main/graphql/types.generated';
import { forwardRef } from 'react';

import { PolicyConfigSharepoint } from './policy-config-sharepoint';
import type { PolicyConfigProps, PolicyConfigRef } from './types';

export type PolicyIntegrationConfigProps = PolicyConfigProps & {
  providerName: Integration_Names_Enum;
};

export const PolicyIntegrationConfig = forwardRef<PolicyConfigRef, PolicyIntegrationConfigProps>(
  ({ providerName, ...rest }, ref) => {
    switch (providerName) {
      case Integration_Names_Enum.Sharepoint:
        return <PolicyConfigSharepoint ref={ref} {...rest} />;
      default:
        throw new Error(`No policy config component for provider "${providerName}"`);
    }
  },
);
PolicyIntegrationConfig.displayName = 'PolicyIntegrationConfig';
